import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Mail } from 'lucide-react';
import SEOHead from '../components/seo/SEOHead';

export default function NotFoundPage() {
  return (
    <>
      <SEOHead
        title="Página no encontrada | Valoriza Innovation Hub"
        description="La página que buscas no existe o se ha movido."
        path="/404"
        noindex
      />
      <div className="pt-40 pb-32 v-container text-center" data-testid="not-found-page">
        <span className="v-tag green mb-6 inline-flex">Error 404</span>
        <h1 className="text-3xl sm:text-4xl font-bold text-black dark:text-white/95 mb-4 tracking-tight">
          Esta página no existe
        </h1>
        <p className="text-base text-gray-700 dark:text-white/65 max-w-md mx-auto mb-10 leading-relaxed">
          Puede que el enlace esté roto o que la página se haya movido. Vuelve al inicio o escríbenos.
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <Link to="/" className="btn-primary flex items-center gap-2" data-testid="not-found-home-link">
            <Home size={16} /> Volver al inicio
          </Link>
          <a href="mailto:innovation@valorizasm.com" className="btn-secondary flex items-center gap-2" data-testid="not-found-contact-link">
            <Mail size={16} /> Escribir a innovación
          </a>
        </div>
      </div>
    </>
  );
}
